import React from "react";
import { Subject } from "rxjs";
import { observer } from "mobx-react";  
import { AuthService, ItemBenefitsService } from "../services";
import { AddUpdateBenefitStore, BenefitsModel } from "../models";
import { BenefitModalWrapper, CustomLabel, FlexContainer, Input, ModalComponent, SapphireBlueButton } from "@mindmemobile/mm-shared-global";
import { IAPIBenefitsModels } from "../interfaces"; 

type Props = {
  onClose: (benefit?: BenefitsModel) => void;
  benefitsService: ItemBenefitsService;
};

@observer
class AddBenefitModal extends React.Component<Props> {
  public booleanSubject = new Subject<BenefitsModel | undefined>();
  public upsertBenefitStore = new AddUpdateBenefitStore();

  get body() {
      const { upsertBenefit } = this.upsertBenefitStore;
      return (
          <div>
              <CustomLabel>
                  Award Benefits on purchases and payments. Current Benefits include
                  <br /> <b>Session</b>, <b>Lesson</b> and <b>Visit</b>.
              </CustomLabel>
              <FlexContainer spacing={30} justifyContent="center" className="enhancement-inputs">
                  <div>
                      <CustomLabel margin="0px 0px 10px">Individual</CustomLabel>
                      {this.input('singularName', upsertBenefit.singularName, 'Enhancement')}
                  </div>
                  <div>
                      <CustomLabel margin="0px 0px 10px">Plural</CustomLabel>
                      {this.input('pluralName', upsertBenefit.pluralName, 'Enhancements')}
                  </div>
              </FlexContainer>
              <CustomLabel fontSize="12px" lineHeight="14px">
                  Add anything to track based on the service or membership you offer. Popular choices include
                  <br /> classes, sessions, lessons, appointments, visits, repairs, inspections, massages and points.
              </CustomLabel>
          </div>
      );
  }

  input(key: keyof BenefitsModel, value: string, placeholder: string) {
      const hasError = this.upsertBenefitStore.upsertBenefit.errors.some((e) => e.field === key);
      return (
          <Input
              value={value}
              type="text"
              error={hasError}
              onChange={(e) => this.updateState(key, e.target.value)}
              placeholder={placeholder}
          />
      );
  }

  updateState = (key: keyof BenefitsModel, value: string) => {
      switch (key) {
          case 'singularName':
              this.upsertBenefitStore.update(
                  new BenefitsModel({
                      ...this.upsertBenefitStore.upsertBenefit,
                      singularName: value,
                  }),
              );
              break;
          case 'pluralName':
              this.upsertBenefitStore.update(
                  new BenefitsModel({
                      ...this.upsertBenefitStore.upsertBenefit,
                      pluralName: value,
                  }),
              );
              break;
      }
  };

  onSubmit() {
      const { upsertBenefit } = this.upsertBenefitStore;
      const isValid = this.upsertBenefitStore.validate();
      if (!isValid) return;
      if (upsertBenefit.singularName && upsertBenefit.pluralName) {
          this.props.benefitsService.addBenefit(
              {
                  accountId: AuthService.authData.accountId,
                  singularName: upsertBenefit.singularName,
                  pluralName: upsertBenefit.pluralName,
              } as IAPIBenefitsModels,
              this.booleanSubject,
          );

          this.booleanSubject.subscribe({
              next: (benefit) => {
                  if (benefit) {
                      this.props.onClose(benefit);
                  }
              },
              error: (e) => {
                  console.error(e);
              },
          });
      }
  }

  render() {
      return (
          <BenefitModalWrapper>
              <ModalComponent
                  title="New Benefit"
                  titleFontSize="22px"
                  bodyPadding="50px 30px"
                  onClose={() => this.props.onClose(undefined)}
                  showFooter={true}
                  wrapperWidth="600px"
                  bodyBackgroundColor="#F4F7FB"
                  footerHeight="auto"
                  footerContent={
                      <FlexContainer alignItems="center" justifyContent="center" spacing={15}>
                          <SapphireBlueButton minWidth="120px" height="40px" onClick={() => this.props.onClose()}>
                              Cancel
                          </SapphireBlueButton>
                          <SapphireBlueButton primary minWidth="120px" height="40px" onClick={() => this.onSubmit()}>
                              Save
                          </SapphireBlueButton>
                      </FlexContainer>
                  }
              >
                  {this.body}
              </ModalComponent>
          </BenefitModalWrapper>
      );
  }
}

export default AddBenefitModal;
